// /**
// * Checks browser is running on a native mobile device
// */
export const isMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  return (
    /windows phone/i.test(userAgent) ||
    /android/i.test(userAgent) ||
    (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
  );
};

// /**
// * Checks iOS user agent
// */
export const iOS = () => {
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};

// /**
// * Returns if media query matches mobile
// */
export const isMobile = () => {
  return window.matchMedia('(max-width: 767px)').matches;
};

// /**
// * Returns if media query matches tabletLandscape
// */
export const isTabletLandscape = () => {
  return window.matchMedia('(max-width: 1023px)').matches;
};

// /**
// * Returns the browser's scrollbar width
// */
export const getScrollbarWidth = () => {
  return window.innerWidth - document.documentElement.clientWidth;
};

// /**
// * Checks if an element is focusable
// *
// * @param {Object} el - HTML element you want to check if it's focusable
// */
export const isFocusable = el => {
  if (
    el.tabIndex > 0 ||
    (el.tabIndex === 0 && el.getAttribute('tabIndex') !== null)
  ) {
    return true;
  }

  if (el.disabled) {
    return false;
  }

  /* eslint-disable indent */
  switch (el.nodeName) {
    case 'A':
      return !!el.href && el.rel !== 'ignore';
    case 'INPUT':
      return el.type !== 'hidden' && el.type !== 'file';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return false;
  }
  /* eslint-enable indent */
};

// /**
// * FOCUSABLE ELEMENTS
// */
export const focusableElements = [
  '[contenteditable]',
  '[tabindex]:not([tabindex^="-"])',
  'a[href]',
  'area[href]',
  'button:not([disabled]):not([aria-hidden])',
  'embed',
  'iframe',
  'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
  'object',
  'select:not([disabled]):not([aria-hidden])',
  'textarea:not([disabled]):not([aria-hidden])'
];

// * Check if an element is outside the viewport
// */
export const isOutOfViewport = elem => {
  // Get element's bounding
  const bounding = elem.getBoundingClientRect();

  // Check if it's out of the viewport on each side
  const out = {};
  out.top = bounding.top < 0;
  out.left = bounding.left < 0;
  out.bottom =
    bounding.bottom >
    (window.innerHeight || document.documentElement.clientHeight);
  out.right =
    bounding.right >
    (window.innerWidth || document.documentElement.clientWidth);
  out.any = out.top || out.left || out.bottom || out.right;
  out.all = out.top && out.left && out.bottom && out.right;

  return out;
};

export const sameOrigin = (uri1, uri2 = false) => {
  if (uri1[0] === '/') return true;
  if (uri1[0] === '/' && uri2[0] === '/') return true;
  if (!uri2) uri2 = window.location.href;

  uri1 = new URL(uri1);
  uri2 = new URL(uri2);

  const host1 = uri1.hostname.split('www.')[1];
  const host2 = uri2.hostname.split('www.')[2];

  if (host1 !== host2) return false;
  if (uri1.port !== uri2.port) return false;

  return true;
};

// * Check if child is a descendant of parent
// */
export const isDescendant = (parent, child) => {
  let node = child.parentNode;

  while(node) {
    if (node === parent) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
};

// * Decode HTML entities
// */
export const decodeEntity = str => {
  const ta = document.createElement('textarea');
  ta.innerHTML = str;
  return ta.value;
};

// * Returns a sanitized string to safely populate id parameters in HTML tags
// */
export const getSafeId = str => {
  //return str.replace(/\W/g, '_');
  return str;
};

// * Returns a random integer between min (inclusive) and max (inclusive).
// */
export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const sortFiltersBySitecore = (
  unsortedFilters,
  sitecoreFilters = []
) => {
  const filtersInSitecore = unsortedFilters.filter(
    facet => sitecoreFilters.indexOf(facet.value) > -1
  );

  const remainingFilters = unsortedFilters.filter(
    facet => sitecoreFilters.indexOf(facet.value) === -1
  );

  const sortRemainingFilters = remainingFilters.sort((a, b) => {
    if (a.value.toLowerCase() > b.value.toLowerCase()) {
      return 1;
    }
    return -1;
  });

  const filtersInSitecoreOrdered = filtersInSitecore.sort(
    (a, b) =>
      sitecoreFilters.indexOf(a.value) - sitecoreFilters.indexOf(b.value)
  );

  return [...filtersInSitecoreOrdered, ...sortRemainingFilters];
};

export const BREAKPOINTS = Object.freeze({
  mobile: 361,
  tablet: 769,
  tabletLandscape: 1025,
  desktop: 1281,
  moduleMax: 1251,
  wide: 1601
});

export const debounce = (callback, wait) => {
  let timerId;
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      callback(...args);
    }, wait);
  };
};
